/* eslint-disable */
import { takeEvery, call, put } from 'redux-saga/effects';
import { GET_CORDERDETAIL, SET_CORDERDETAIL, GET_PRINTORDER, SET_PRINTORDER} from '../actions';
import {  apiUrl } from "../components/Helpers/Config";
import Axios from 'axios';
import cookie from 'react-cookies';

export const watchGetCorderDetail = function* () {
  yield takeEvery(GET_CORDERDETAIL, workerGetCorderDetail);
}

function* workerGetCorderDetail({ deliveryparams }) {
  try {
    const uri = apiUrl+'chopchop/reports/order_transaction_history?order_status=C'+deliveryparams;
    const result = yield call(Axios.get, uri);
	var resultArr = [];
	resultArr.push(result.data);
    yield put({ type: SET_CORDERDETAIL, value: resultArr });
  } 
  catch {
    console.log('Get Current order Failed');
  }
} 

